import React, { useState } from 'react';
import styled from 'styled-components/native';
import { View, Text } from 'react-native';
import { dollars, numberWithDelimiter } from 'app/src/utils/stringHelpers';

import {
  Field,
  Label,
  StyledTextInput,
  Button,
  SuggestionsContainer,
  PaddleStepsContainer,
  PaddleServiceLabel,
  PaddleStepsRow,
  CustomBidButton,
} from '../elements';
import colors from 'app/src/styles/colors';

const BidSuggestions = ({ saleAsset, price, setPrice, enterBid }) => {
  const [editNext, setEditNext] = useState(false);
  const [nextManual, setNextManual] = useState('');
  const biddingStep = saleAsset.biddingStep;
  const biddingNext = saleAsset.biddingNext || biddingStep;
  const suggestions = [-1,0,1,2,3].map(step => {
    let divisor = step < 0 ? 2 : 1;
    let multiplier = step / divisor;
    return (biddingNext + (multiplier * biddingStep)).toFixed(0)
  });

  const paddleServices = [
    {id: 5, code: 'EL', color: colors.biddingELGreen},
    {id: 1, code: 'PB', color: colors.biddingPBCyan},
    {id: 2, code: 'EF', color: colors.biddingEFTurquoise},
    {id: null, code: 'FL', color: colors.biddingFLBlue}
  ];

  const handleKeyPress = (e, action) => {
    if ('Enter' === e.nativeEvent.key) {
      (action || enterBid)();
    }
  };

  const handleKeyDownNextManual = e => {
    if ('Escape' === e.nativeEvent.key) {
      setEditNext(false);
      setNextManual('')
    }
  }

  return (
    <>
      <SuggestionsContainer>
        {/* <Label style={{minWidth: 100}}>Enter Bid</Label> */}
        <PaddleStepsContainer>
          {paddleServices.map(paddleService => {
            return (
              <PaddleStepsRow key={`row-${paddleService.id}`}>
                <PaddleServiceLabel key={`key-${paddleService.id}`}>
                  {paddleService.code}:
                </PaddleServiceLabel>
                {suggestions.map((suggestion, index) => (
                  <React.Fragment key={suggestion}>
                    <Button
                      key={`suggestion-${paddleService.id}`}
                      color={paddleService.color}
                      title={numberWithDelimiter(suggestion)}
                      onPress={() => enterBid(suggestion, paddleService.id)}
                      labelStyle={{ color: 'black', fontWeight: 800 }}
                    />
                  </React.Fragment>
                ))}
              </PaddleStepsRow>
            )
          })}
        </PaddleStepsContainer>
      </SuggestionsContainer>
      <View style={{ flexDirection: 'row' }}>
        <View
          style={{
            flexDirection: 'row',
            flex: 1,
            justifyContent: 'space-between',
            marginBottom: '10px',
            marginTop: '-10px',
          }}
        >
          <Field style={{ width: '90%' }}>
            <Label style={{minWidth: 50}}>Enter Custom Bid:</Label>
            <StyledTextInput
              onChange={e => setPrice(e.target.value)}
              value={price || ''}
              onKeyPress={handleKeyPress}
              style={{ width: 50, marginRight: '2.5px' }}
            />
            {
              paddleServices.map(paddleService => (
                <CustomBidButton
                  title={paddleService.code}
                  color={paddleService.color}
                  onPress={() => price && enterBid(price, paddleService.id)}
                  labelStyle={{ color: 'black' }}
                  style={{maxWidth: '50px', marginLeft: '2.5px', marginRight: '2.5px'}}
                />
              ))
            }
          </Field>
        </View>
      </View>
    </>
  )
}

export default BidSuggestions;
